import { render, staticRenderFns } from "./datatable-client.vue?vue&type=template&id=d9e1c4d6"
import script from "./datatable-client.vue?vue&type=script&lang=js"
export * from "./datatable-client.vue?vue&type=script&lang=js"
import style0 from "./datatable-client.vue?vue&type=style&index=0&id=d9e1c4d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports